import { render, staticRenderFns } from "./detail-creation.vue?vue&type=template&id=fd674cfa"
import script from "./detail-creation.vue?vue&type=script&lang=js"
export * from "./detail-creation.vue?vue&type=script&lang=js"
import style0 from "./detail-creation.vue?vue&type=style&index=0&id=fd674cfa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports